import { type CSSObject } from '@emotion/react'
import { cssTokenVariables } from '../styles'

export const dotToken = {
  backgroundColor: `var(${cssTokenVariables.colorBackground})`,
  blockSize: `var(${cssTokenVariables.tokenSize})`,
  border: `var(${cssTokenVariables.tokenBorder})`,
  borderRadius: '50%',
  display: 'block',
  inlineSize: `var(${cssTokenVariables.tokenSize})`,
  minInlineSize: `var(${cssTokenVariables.tokenSize})`,
  minBlockSize: `var(${cssTokenVariables.tokenSize})`,
  '&:hover': {
    border: `var(${cssTokenVariables.tokenHoverBorder})`,
  },
} as const satisfies CSSObject
